import { AnimatedPanToOptions } from "../types/mapUtils.type";
import { getProjectedBounds, isPositionVisible } from "./mapUtils";
import { smoothZoomIn } from "./smoothZoom";

export const animatedPanTo = async ({
  map,
  newCenter,
  finalZoom = 12,
  onStartAnimation,
  onEndAnimation,
  onZoomOutCurrentPosition,
  onSetFinalPosition,
}: AnimatedPanToOptions) => {
  onStartAnimation?.();

  const currentCenter = map.getCenter();

  if (!currentCenter) {
    map.panTo(new google.maps.LatLng(newCenter.lat, newCenter.lng));
    map.setZoom(finalZoom);
    return onEndAnimation?.();
  };

  let isNewCenterVisible = isPositionVisible(map, newCenter);
  let currentZoom = map.getZoom();

  if (currentZoom && currentZoom > 1) {
    while (!isNewCenterVisible && currentZoom > 1) {
      currentZoom--;

      map.setZoom(currentZoom);

      await new Promise(res => setTimeout(res, 100));

      isNewCenterVisible = isPositionVisible(map, newCenter);
    }
  }

  onZoomOutCurrentPosition?.();

  await new Promise(res => setTimeout(res, 400));

  map.panTo(new google.maps.LatLng(newCenter.lat, newCenter.lng));

  const finalBounds = getProjectedBounds({
    center: newCenter,
    zoom: finalZoom,
    mapWidth: map.getDiv().getBoundingClientRect().width,
    mapHeight: map.getDiv().getBoundingClientRect().height,
  });

  onSetFinalPosition?.(finalBounds);

  await new Promise(res => setTimeout(res, 400));

  const newZoom = map.getZoom();

  if (newZoom && newZoom < finalZoom) {
    await smoothZoomIn({
      map,
      initialZoom: newZoom,
      finalZoom,
    });
  } else {
    map.setZoom(finalZoom);
  }

  return onEndAnimation?.();
};
